// extracted by mini-css-extract-plugin
module.exports = {"container":"SrcSet_container__LrIJs","image":"SrcSet_image__0OtgM"};